import { tokenStorage } from "../auth";
import { rawApiRequest, authenticatedApiRequest } from "./core";
import type { LoginResponse, User } from "@/types";

export const authApi = {
  getCurrentUser: async (): Promise<User> => {
    return authenticatedApiRequest<User>("/accounts/auth/users/me/");
  },

  stytchExchange: async (sessionToken: string, sessionJwt?: string): Promise<LoginResponse> => {
    return rawApiRequest<LoginResponse>("/accounts/auth/stytch/exchange/", {
      method: "POST",
      body: JSON.stringify({
        session_token: sessionToken,
        ...(sessionJwt ? { session_jwt: sessionJwt } : {}),
      }),
    });
  },

  requestStytchMagicLink: async (email: string, loginRedirectUrl: string): Promise<void> => {
    return rawApiRequest<void>("/accounts/auth/stytch/magic-link/", {
      method: "POST",
      body: JSON.stringify({
        email,
        login_redirect_url: loginRedirectUrl,
      }),
    });
  },

  requestInternalDocsAccess: async (): Promise<{ url: string }> => {
    return authenticatedApiRequest<{ url: string }>("/accounts/auth/internal-docs/", {
      method: "POST",
      credentials: "include",
    });
  },

  logout: (): void => {
    tokenStorage.remove();
  },
};
